import { useState } from 'react';
import useFetch from './useFetch'
import { apiWrapper } from '../dataHooks/dataHookUtils'

export default () => {
  const [isMigrationAttemptOccuring, setIsMigrationAttemptOccuring] = useState(false)
  const [attemptedManualSessionLoad, setAttemptedManualSessionLoad] = useState(false)

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const attemptSessionMigrationApi = async (eventId) => {
    setIsMigrationAttemptOccuring(true)
    const result = await
      apiWrapper({
        fetch,
        url: `events/event/sessions/migrate`,
        options: {
          method: 'POST', 
          headers: postHeaders,
          body: JSON.stringify({ eventId })
        }
      });
      setIsMigrationAttemptOccuring(false)
    return result;
  }

  const attemptSessionMigration = async (eventId, callbackFn) => {
    try{
      const result = await attemptSessionMigrationApi(eventId)
      if (result && result.success && callbackFn) {
        callbackFn()
      }
    } catch(e) {
      console.log(e)
    }
    setAttemptedManualSessionLoad(true)
  }

  const attemptInitialSessionFromEventTemplateLoadApi = async (eventId) => {
    setIsMigrationAttemptOccuring(true)
    const result = await
      apiWrapper({
        fetch,
        url: `events/event/sessions/templateLoadCheck`,
        options: {
          method: 'POST', 
          headers: postHeaders,
          body: JSON.stringify({ eventId })
        }
      });
      setIsMigrationAttemptOccuring(false)
    return result;
  }

  const attemptInitialSessionFromEventTemplateLoad = async (eventId, callbackFn) => {
    try{
      const result = await attemptInitialSessionFromEventTemplateLoadApi(eventId)
      if (result && result.success && callbackFn) {
        callbackFn()
      }
    } catch(e) {
      console.log(e)
    }
    setAttemptedManualSessionLoad(true)
  }

  return {
    isMigrationAttemptOccuring,
    attemptedManualSessionLoad,
    attemptSessionMigration,
    attemptInitialSessionFromEventTemplateLoad
  }
}